module.exports = __webpack_public_path__ + "static/img/sunxiaojun2.f20a430.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/sunxiaojun2.jpg
// module id = vjdh
// module chunks = 1